import { render, staticRenderFns } from "./blog-detail.vue?vue&type=template&id=37069c96&scoped=true&"
import script from "./blog-detail.vue?vue&type=script&lang=ts&"
export * from "./blog-detail.vue?vue&type=script&lang=ts&"
import style0 from "./blog-detail.vue?vue&type=style&index=0&id=37069c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37069c96",
  null
  
)

export default component.exports